export const UI_DATE_FORMAT = "MM/dd/yyyy";
export const EMPTY_FALLBACK = "–";
export const LOCALE = "en-US";
